import { ApplicationState, AppThunkDispatch } from "../../store";
import { connect } from "react-redux";
import AppointmentsTable from "../../components/AppointmentsTable";
import { AppointmentsTableStateProps, AppointmentsTableDispatchProps } from "../../components/AppointmentsTable/AppointmentsTable";
import { loadEntities, updateEntity, openAppointment } from "../../store/entities/actions";
import { ProfessionalEntity } from "../../store/entities/state";
import { getAppointmentsForProfessional, isLoadingEntities } from "../../store/entities/selectors";
import { getProfessionalAppointmentsAsync, updateAppointmentAsync } from "../../ajax/requests";
import { AppointmentData } from "../../models";
import { canEditAppointments } from "../../store/session/selectors";

export interface ProfessionalAppointmentsTableProps {
    professional: ProfessionalEntity,
}

const mapStateToProps = (state: ApplicationState, ownProps: ProfessionalAppointmentsTableProps): AppointmentsTableStateProps => ({
    appointments: getAppointmentsForProfessional(ownProps.professional.id)(state),
    isLoading: isLoadingEntities('appointments')(state),
    canEdit: canEditAppointments(state),
    settings: {hideColumns: ['professional']}
})

const mapDispatchToProps = (dispatch: AppThunkDispatch, ownProps: ProfessionalAppointmentsTableProps): AppointmentsTableDispatchProps => ({
    onLoadMore: (offset: number) => {
        dispatch(loadEntities(
            'appointments', 
            pageSize => getProfessionalAppointmentsAsync(ownProps.professional.id, pageSize, offset), 
            offset ? 'AppendResult' : 'NewResult',
            e => !offset && e.professionalId === ownProps.professional.id));
    },
    onEditAppointment: (appointment: AppointmentData) => dispatch(openAppointment(appointment.id)),
    onMarkAppointmentDone: (appointment: AppointmentData) => dispatch(
        updateEntity('appointments', { ...appointment, hasHappened: !appointment.hasHappened }, a => updateAppointmentAsync(a.id, {data: a}))),
});

export default connect<AppointmentsTableStateProps, AppointmentsTableDispatchProps, ProfessionalAppointmentsTableProps, ApplicationState>(
    mapStateToProps,
    mapDispatchToProps,
)(AppointmentsTable as any);